<template>
  <div>
    <hr class="dropdown-divider" />
    <div class="dropdown-item">
      <div class="subtitle is-6">{{ $t("developer tools") }}</div>
    </div>
    <a class="dropdown-item" @click="update_git">
      <span class="icon has-text-info">
        <i class="fa fa-git"></i>
      </span>
      <span>{{ $t("update") }}</span>
    </a>
    <a class="dropdown-item" @click="custom_build">
      <span class="icon has-text-danger">
        <i class="fa fa-file-text-o"></i>
      </span>
      <span>{{ $t("generate custom_build") }}</span>
    </a>
    <a class="dropdown-item" @click="make_build">
      <span class="icon has-text-success">
        <i class="fa fa-rocket"></i>
      </span>
      <span>{{ $t("make build") }}</span>
    </a>
    <a class="dropdown-item" @click="generate_models">
      <span class="icon has-text-warning">
        <i class="fa fa-database"></i>
      </span>
      <span>{{ $t("generate models") }}</span>
    </a>
    <a class="dropdown-item" @click="reset">
      <span class="icon has-text-danger">
        <i class="fa fa-refresh"></i>
      </span>
      <span>{{ $t("reset") }}</span>
    </a>
    <a class="dropdown-item" @click="reset_apy">
      <span class="icon has-text-info">
        <i class="fa fa-refresh"></i>
      </span>
      <span>{{ $t("restart apy") }}</span>
    </a>
    <hr class="dropdown-divider" />
    <a class="dropdown-item" @click="$router.push({ path: '/module' })">
      <span class="icon">
        <i class="fa fa-cubes"></i>
      </span>
      <span>{{ $t("modules") }}</span>
    </a>
    <!-- <a class="dropdown-item" @click="$router.push({ path: '/system' })">
      <span class="icon">
        <i class="fa fa-cogs"></i>
      </span>
      <span>{{ $t("system") }}</span>
    </a> -->
    <a class="dropdown-item" @click="$router.push({ path: '/core' })">
      <span class="icon">
        <i class="fa fa-cog"></i>
      </span>
      <span>{{ $t("core") }}</span>
    </a>
    <a class="dropdown-item" @click="$router.push({ path: '/api/settings' })">
      <span class="icon">
        <i class="fa fa-server"></i>
      </span>
      <span>{{ $t("api manager") }}</span>
    </a>
    <a
      class="dropdown-item"
      @click="$router.push({ path: '/report/settings' })"
    >
      <span class="icon">
        <i class="fa fa-file-text-o"></i>
      </span>
      <span>{{ $t("report manager") }}</span>
    </a>
    <!-- <hr class="dropdown-divider" />
    <a class="dropdown-item" @click="$emit('terminal')">
      <span class="icon has-text-danger">
        <i class="fa fa-code"></i>
      </span>
      <span>{{ $t("terminal") }}</span>
    </a> -->
    <hr class="dropdown-divider" />
    <a class="dropdown-item" @click="install_api">
      <span class="icon has-text-info">
        <i class="fa fa-tint"></i>
      </span>
      <span>{{ $t("install api") }}</span>
    </a>
    <a class="dropdown-item" @click="reinstall_api">
      <span class="icon has-text-primary">
        <i class="fa fa-umbrella"></i>
      </span>
      <span>{{ $t("reinstall api") }}</span>
    </a>
    <a class="dropdown-item" @click="install_frontend">
      <span class="icon has-text-warning">
        <i class="fa fa-tree"></i>
      </span>
      <span>{{ $t("install frontend") }}</span>
    </a>
    <a class="dropdown-item" @click="reinstall_frontend">
      <span class="icon has-text-success">
        <i class="fa fa-taxi"></i>
      </span>
      <span>{{ $t("reinstall frontend") }}</span>
    </a>
  </div>
</template>

<script>
import {
  get,
  put,
  post,
  success_message,
  error_message,
  get_user_data,
  // confirm_deletion_dialog,
} from "@/utils";

export default {
  name: "DevTools",
  components: {},
  data() {
    return {
      user_data: get_user_data(),
    };
  },
  methods: {
    custom_build() {
      let v = this;
      // console.log("custom_build", v);
      v.$root.loader(true);
      put("/module/custom_build", {})
        .then(() => {
          // console.log("build_custom_routes finished");
          success_message(v.$t("custom_build file generated"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    update_git() {
      let v = this;
      v.$root.loader(true);
      put("/module/update", {})
        .then((stdout) => {
          success_message(stdout);
          // success_message(stdout);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
          v.is_waiting_for_build = false;
        });
    },
    make_build() {
      let v = this;
      v.$root.loader(true);
      put("/module/build", { _timeout: 60000 * 30 })
        .then((stdout) => {
          console.log(stdout);
          success_message(v.$t("build finished"));
          setTimeout(() => {
            location.reload(true);
          }, 1000);
          // success_message(stdout);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
          v.is_waiting_for_build = false;
        });
    },
    reset() {
      let v = this;
      v.$root.loader(true);
      get("/core/restart", {})
        .then(() => {
          success_message(v.$t("restarting modul"));
          let connection_succeded = false;
          for (let i = 1; i <= 30; i++) {
            setTimeout(() => {
              if (connection_succeded) return;

              console.log("trying to get response from server, attempt", i + 1);
              get("/system/settings", {})
                .then(() => {
                  connection_succeded = true;
                  v.$root.loader(false);
                  success_message(v.$t("modul restarted"));
                })
                .catch((error) => {
                  console.log("error", error);
                });
            }, 1000 * i);
          }
        })
        .catch((error) => {
          v.$root.loader(false);
          error_message(error);
        });
    },
    reset_apy() {
      let v = this;
      v.$root.loader(true);
      post("/core/restart-apy", {})
        .then(() => {
          success_message(v.$t("modul apy restarted"));
        })
        .catch((error) => {
          v.$root.loader(false);
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    generate_models() {
      let v = this;
      v.$root.loader(true);
      get("/core/generate-models", {})
        .then((response) => {
          success_message(v.$t("models generated"));
          console.log(response);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    install_api() {
      let v = this;
      v.$root.loader(true);
      get("/core/install-api", {})
        .then((response) => {
          success_message(response);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    reinstall_api() {
      let v = this;
      v.$root.loader(true);
      get("/core/reinstall-api", {})
        .then((response) => {
          success_message(response);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    install_frontend() {
      let v = this;
      v.$root.loader(true);
      get("/core/install-frontend", {})
        .then((response) => {
          success_message(response);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    reinstall_frontend() {
      let v = this;
      v.$root.loader(true);
      get("/core/reinstall-frontend", {})
        .then((response) => {
          success_message(response);
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>
